// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__INPB6","loader":"Tag_loader__UXjPX","spin":"Tag_spin__9gwVC","secondary-tag":"Tag_secondary-tag__wyp9M"};